import { useState } from 'react'
import { RotateCw } from 'lucide-react'
import { PageHeader } from '@/shell/AppShell'
import { useToast } from '@/providers/UiProviders'
import { restartService, DT_STR as S } from './devtoolsApi'

/**
 * A27.12 — Перезапуск сервиса. FUNCTIONAL: one button per service → the real
 * `POST /admin/devtools/restart {service}`. ⚠️ Superadmin-only + env-gated
 * (DEVTOOLS_RESTART_ENABLED) — the endpoint enforces both; every call is audited.
 */
export function RestartScreen() {
  const { toast } = useToast()
  const [busy, setBusy] = useState<string | null>(null)

  const services = [
    { id: 'api', label: S.svcApi },
    { id: 'gateway', label: S.svcGateway },
    { id: 'worker', label: S.svcWorker },
  ]

  const restart = async (service: string) => {
    setBusy(service)
    try {
      await restartService(service)
      toast(S.restarted, { tone: 'success' })
    } catch {
      toast(S.failed, { tone: 'error' })
    } finally {
      setBusy(null)
    }
  }

  return (
    <>
      <PageHeader title={S.restart} screenId="A27.12" />
      <div className="grid max-w-2xl grid-cols-1 gap-3 p-4 sm:grid-cols-3">
        {services.map((sv) => (
          <button
            key={sv.id}
            type="button"
            onClick={() => restart(sv.id)}
            disabled={busy !== null}
            className="flex flex-col items-start gap-2 rounded-md border border-border-default bg-surface-1 p-4 text-left hover:border-border-strong disabled:opacity-50"
          >
            <RotateCw size={18} className="text-secondary" />
            <span className="text-sm font-medium text-primary">{sv.label}</span>
            <span className="text-xs text-secondary">
              {busy === sv.id ? S.running : S.restart}
            </span>
          </button>
        ))}
      </div>
    </>
  )
}
